import { Container, Row, Col } from '@ui/wrapper'
import TeamMember from '@components/team-member'
import SectionTitle from '@ui/section-title'
import { TeamWrapper, StyledText } from './style'

const TeamArea = ({ data, ...rest }) => {
  return (
    <TeamWrapper {...rest}>
      <Container px={[null, null, null, '30px']}>
        {data?.texts?.[0] && (
          <StyledText
            dangerouslySetInnerHTML={{
              __html: data.texts[0].content
            }}
          />
        )}
        {data?.section_title && (
          <SectionTitle
            mb={['45px', null, null, '70px']}
            {...data.section_title}
          />
        )}
        <Row
          gutters={{ lg: 60 }}
          className="justify-content-center d-flex"
          style={{ margin: '0 -15px' }}
        >
          {data?.items?.map((member) => (
            <Col
              md={4}
              key={member.id}
              mb="30px"
              style={{
                paddingLeft: '50px',
                paddingRight: '50px',
                paddingBottom: '10px'
              }}
            >
              <TeamMember
                layout={2}
                image={member.images?.[0]}
                name={member.name}
                designation={member.designation}
                socials={member.socials}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </TeamWrapper>
  )
}

export default TeamArea
